module.exports = __webpack_public_path__ + "img/icon_chevron_up.01aafaa6.svg";